<p><label id="pageMsg">Error</label></p>
<br />
<div style="text-align:center"><button id="btnOK" class="btn  btn-danger btn-lg" (click)="onCloseClick()"> OK </button></div>
